import {remote} from '../constants/environment';
import {ITermsResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const getTyc = async (): Promise<ITermsResponse> => {
  const remoteURI = remote.getTycUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: defaultHeaders,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const {success, payload} = await response.json();
        const {tyc} = payload;
        return {
          success,
          payload: {
            tyc,
          },
        };
      }
    },
    remoteURI,
  )) as ITermsResponse;
};
